<template>
    <div class="transcoding-progress status-play" @click="handlePreview">
        <PlaySvg/>
    </div>
</template>

<script>
import PlaySvg from '@/components/svg/PlaySvg';

export default {
    name: 'StatusPlay',
    components: {
        PlaySvg,
    },
    methods: {
        handlePreview() {
            this.$emit('handlePreview');
        },
    },
};
</script>

